
import React from 'react';
import { FeatureShowcase } from '@/components/subscription/FeatureShowcase';

export function CommunityPreview() {
  const benefits = [
    "Connect with fellow exam aspirants for collaborative learning",
    "AI-matched study groups based on your goals and level",
    "Discussion forums for doubt clearing and knowledge sharing",
    "Live quiz battles to compete and learn with peers",
    "Share and access community-created study materials",
    "Build your learning network with like-minded students"
  ];
  
  const screenshots = [
    {
      url: "/lovable-uploads/bb998b73-27d3-4993-8be1-46cd6b5a0501.png",
      caption: "Comparative Peer Analytics - See how you perform against others"
    }
  ];

  return (
    <FeatureShowcase
      title="Learning Community"
      description="Connect, collaborate, and compete with peers to enhance your learning experience."
      featureName="Community"
      benefits={benefits}
      screenshots={screenshots}
    />
  );
}
